import BuscarMiembro from "../components/cards/membership/BuscarMiembro";
import PieChart from "../components/charts/PieChart";
import { Link } from "react-router-dom";
import { apiBaseUrl } from "./config";
import { renderRoles } from './utils';

const baseUrl = `${apiBaseUrl}/dashboard`;

function getMembersPath(year) {
  if (!year) {
    return '/app/members';
  }
  return `/app/members?ciclo=${year}`;
}

async function getDashboard(token, year) {
  const url = `${baseUrl}/${year ? `?year=${year}` : ''}`;
  let cards = [];

  try {
    const r = await fetch(url, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
    });
    const data = await r.json();
    if (!r.ok) {
      throw data;
    }

    if (data.type === 'member') {
      cards = getMemberDashboardContent(data.user.user);
      return {
        type: 'member',
        cards: cards
      }
    }
    else if (data.type === 'team-coordinator') {
      cards = getMemberDashboardContent(data.user.user);
      return {
        type: 'team-coordinator',
        cards: cards,
        fullData: data
      }
    }

    let title = 'Dashboard';
    let type = 'admin';
    switch (data.level) {
      case 1:
        cards = getDashboardNacionalContent(data, year);
        title += ' Nacional';
        break;

      case 2:
        cards = getDashboardRegionalContent(data, year);
        title = data.members[0].label;
        break;

      case 3:
        cards = getDashboardDiocesisContent(data, year);
        title = data.members[0].diocesis[0].label;
        break;

      case 4:
        cards = getDashboardComunidadContent(data, year);
        title = data.members.comunidadLabel;
        type = 'presidente-comunidad';
    }

    return {
      type: type,
      cards: cards,
      title: title,
      org: data.org,
      level: data.level
    }
  }
  catch (e) {
    throw e;
  }
}

async function getDashboardYears(token) {
  const r = await fetch(`${baseUrl}/years`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });
  const data = await r.json();
  if (!r.ok) {
    throw data;
  }
  return data.years || [];
}

function getMemberDashboardContent(user) {
  let nombre;

  switch (user.profile.profile_type_id) {
    case 1:
      nombre = `${user.profile.first_name_1} y ${user.profile.first_name_2} ${user.profile.last_name}`;
      break;

    case 2:
      nombre = `${user.profile.first_name_1} ${user.profile.last_name}`;
      break;

    case 3:
      if (user.profile.asesor_type === 'diacono') {
        nombre = `${user.profile.first_name_1} y ${user.profile.first_name_2} ${user.profile.last_name}`;
      }
      else {
        nombre = `${user.profile.first_name_1} ${user.profile.last_name}`;
      }
      break;
  }

  let address = user.profile.address_1;
  if (user.profile.address_2) {
    address += `, ${user.profile.address_2}`;
  }
  address += `, ${user.profile.city}, ${user.profile.state} ${user.profile.zip_code}`;
  console.log('user', user);

  let cards = [
    {
      title: 'Perfil',
      content: <>
        <p>Nombre: <b>{nombre}</b></p>
        <p>Dirección: <b>{`${address}`}</b></p>
        <p>Teléfono 1: <b>{user.profile.phone_1}</b></p>
        <p>Teléfono 2: <b>{user.profile.phone_2}</b></p>
      </>,
    },
    {
      title: 'Apostolado',
      content: <>
        <p>Apostolado: <b>{renderRoles(user.memberships[0].membership_roles)}</b></p>
        <p>Comunidad: <b>{user.memberships[0].comunidad.label}</b></p>
        <p>Diócesis: <b>{user.memberships[0].diocesis.label}</b></p>
        <p>Región: <b>{user.memberships[0].region.label}</b></p>
      </>,
    },
  ];

  return cards;
}

function getDashboardNacionalContent(data, year) {
  const membersPath = getMembersPath(year);
  let mData = {
    labels: [],
    datasets: [{
      label: '# de miembros',
      borderWidth: 1,
      data: []
    }]
  };
  let total = 0;
  let totalPaid = 0;
  data.members.forEach(region => {
    mData.labels.push(`Región ${region.region_id}`);
    mData.datasets[0].data.push(region.members_count);
    total += region.members_count;
    totalPaid += region.paid_members_count;
  });

  let cards = [
    {
      title: 'Membresía',
      content: <PieChart data={mData} />,
      footer: <Link to={membersPath} className='btn btn-primary'>Ver todos los miembros</Link>
    },
    {
      title: 'Membresía',
      content: <table>
        <thead><tr>
          <td>Región</td><td>Miembros</td><td>Pagados</td>
        </tr></thead>
        <tbody>
          {data.members.map((d, idx) => <tr key={`mem-row-${idx}`}>
            <td key={`mem-label-${idx}`}>{`Región ${d.region_id}`}</td>
            <td key={`mem-data-${idx}`}>{d.members_count}</td>
            <td key={`mem-data-paid-${idx}`}>{d.paid_members_count}</td></tr>)}
          <tr>
            <td key={`mem-label-total`}>Total</td>
            <td key={`mem-data-total`}>{total}</td>
            <td key={`mem-data-paid-total`}>{totalPaid}</td>
          </tr>
        </tbody>
      </table>,
      footer: <Link to={membersPath} className='btn btn-primary'>Ver todos los miembros</Link>
    },
    {
      title: 'Buscar miembro',
      content: <BuscarMiembro />
    },
  ];

  return cards;
}

function getDashboardRegionalContent(data, year) {
  const membersPath = getMembersPath(year);
  let mData = {
    labels: [],
    datasets: [{
      label: '# de miembros',
      borderWidth: 1,
      data: []
    }]
  };
  data.members[0].diocesis.forEach(diocesis => {
    mData.labels.push(`${diocesis.label}`);
    mData.datasets[0].data.push(diocesis.members_count);
  });

  let cards = [
    {
      title: 'Membresía',
      content: <PieChart data={mData} />,
      footer: <Link to={membersPath} className='btn btn-primary'>Ver todos los miembros</Link>
    },
    {
      title: 'Membresía',
      content: <table>
        <thead><tr>
          <td>Diócesis</td><td>Miembros</td><td>Pagados</td>
        </tr></thead>
        <tbody>
          {data.members[0].diocesis.map((d, idx) => <tr key={`mem-row-${idx}`}>
            <td key={`mem-label-${idx}`}>{d.label}</td>
            <td key={`mem-data-${idx}`}>{d.members_count}</td>
            <td key={`mem-data-paid-${idx}`}>{d.paid_members_count}</td></tr>)}
        </tbody>
      </table>,
      footer: <Link to={membersPath} className='btn btn-primary'>Ver todos los miembros</Link>
    },
    {
      title: 'Buscar miembro',
      content: <BuscarMiembro />
    },
  ];

  return cards;
}

function getDashboardDiocesisContent(data, year) {
  const membersPath = getMembersPath(year);
  let mData = {
    labels: [],
    datasets: [{
      label: '# de miembros',
      borderWidth: 1,
      data: []
    }]
  };
  data.members[0].diocesis[0].comunidades.forEach(c => {
    mData.labels.push(`${c.label}`);
    mData.datasets[0].data.push(c.members_count);
  });

  let cards = [
    {
      title: 'Membresía',
      content: <PieChart data={mData} />,
      footer: <Link to={membersPath} className='btn btn-primary'>Ver todos los miembros</Link>
    },
    {
      title: 'Membresía',
      content: <table>
        <thead><tr>
          <td>Comunidad</td><td>Miembros</td><td>Pagados</td>
        </tr></thead>
        <tbody>
          {data.members[0].diocesis[0].comunidades.map((d, idx) => <tr key={`mem-row-${idx}`}>
            <td key={`mem-label-${idx}`}>{d.label}</td>
            <td key={`mem-data-${idx}`}>{d.members_count}</td>
            <td key={`mem-data-${idx}`}>{d.paid_members_count}</td></tr>)}
        </tbody>
      </table>,
      footer: <Link to={membersPath} className='btn btn-primary'>Ver todos los miembros</Link>
    },
    {
      title: 'Buscar miembro',
      content: <BuscarMiembro />
    },
  ];

  return cards;
}

function getDashboardComunidadContent(data, year) {
  const membersPath = getMembersPath(year);
  console.log('data', data);
  let cards = [];

  let mData = {
    labels: [],
    datasets: [{
      label: '# de miembros',
      borderWidth: 1,
      data: []
    }]
  };
  data.members.countByProfileType.forEach(item => {
    mData.labels.push(`${item.label}`);
    mData.datasets[0].data.push(item.members_count);
  });

  cards = [
    {
      title: 'Membresía por tipo',
      content: <PieChart data={mData} />,
      footer: <Link to={membersPath} className='btn btn-primary'>Ver todos los miembros</Link>
    },
    {
      title: 'Membresía',
      content: <table>
        <thead><tr>
          <td>Comunidad</td><td>Miembros</td><td>Pagados</td>
        </tr></thead>
        <tbody>
          {data.members.countByProfileType.map((d, idx) => <tr key={`mem-row-${idx}`}>
            <td key={`mem-label-${idx}`}>{d.label}</td>
            <td key={`mem-data-${idx}`}>{d.members_count}</td>
            <td key={`mem-data-${idx}`}>{d.paid_members_count}</td></tr>)}
        </tbody>
      </table>,
      footer: <Link to={membersPath} className='btn btn-primary'>Ver todos los miembros</Link>
    },
    {
      title: 'Buscar miembro',
      content: <BuscarMiembro />
    },
  ];

  return cards;
}

export {
  getDashboard,
  getDashboardYears
};